import React from 'react';
import { connect } from 'react-redux';
import PWAInstallerPrompt from 'react-pwa-installer-prompt';
import { useApp } from '../../contexts/AppContext';
import PWASidebarBannerContent from './PWASidebarBannerContent';
import { getBrowserDetails, evaluateOrOperator } from '../../utils/helpers';
import { trackPWaMixpanelEventInstalled } from '../../utils/pwa';
import { Account, AccountMaker } from '../../models/Account';
import { RootState } from '../../store';

const { showInstall, showAndroidInstall, showInstallIosChrome } = getBrowserDetails();

interface Props {
  ownAccount: Account;
}

const PWASidebarBanner: React.FC = ({ ownAccount }: Props) => {
  const { setShowIntallationBanner, pwaBannerState, setPwaBannerState, setForceCloseSliderMenu } = useApp();

  return (
    <div>
      {showAndroidInstall && (
        <PWAInstallerPrompt
          render={({ onClick }) => <PWASidebarBannerContent onClick={onClick} />}
          callback={() => {
            setForceCloseSliderMenu(prev => prev + 1);
          }}
        />
      )}
      {evaluateOrOperator(showInstall, showInstallIosChrome) &&
        !ownAccount.data.account_config?.is_account_installed_pwa_in_ios && (
          <PWASidebarBannerContent
            onClick={() => {
              setPwaBannerState(prev => {
                return {
                  ...prev,
                  show: false,
                };
              });
              setShowIntallationBanner(true);
              setForceCloseSliderMenu(prev => prev + 1);
              trackPWaMixpanelEventInstalled(pwaBannerState.source);
            }}
          />
        )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    ownAccount: AccountMaker.create(state.profile),
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PWASidebarBanner);
